import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: {
      translations: {
        'DrawingBoard/empty_caption': 'Start drawing anywhere.',
        'DrawingBoard/clear_title': 'Are you sure you want to erase the entire board?',
        'DrawingBoard/clear_caption': 'This cannot be undone.',
        'DrawingBoard/loading_message': 'Loading — hang tight!',
        'DrawingBoard/tip_undo_autocorrect': 'Tip: You can press Ctrl/Cmd + Z to undo shape correction.',
        'DisconnectMessage/message': 'You are disconnected. You won’t be able to draw while disconnected.',
        'DisconnectMessage/reload': 'Reload',
        'EmailConfirmedMessage/message': 'Thanks for confirming your email, ',
        'EmailConfirmedMessage/dismiss': 'Dismiss',
        'Feedback/feedback': 'Feedback',
        'Feedback/feedback_title': 'Help us improve!',
        'Feedback/feedback_caption': 'Let us know what you think about Witeboard - comments, critiques, questions - anything!',
        'Feedback/feedback_placeholder': 'Your comments',
        'Feedback/enter_helper': 'Press "Enter" to submit your feedback.',
        'Feedback/thank_you': 'Thanks for your feedback!',
        'Item/pencil': 'Pencil',
        'Item/text': 'Text',
        'Item/eraser': 'Eraser',
        'Item/undo': 'Undo',
        'Item/line': 'Line',
        'Title/placeholder': 'Enter a title',
        'Title/enter_helper': 'Press "Enter" to save your title.',
        'Menu/blackboard': 'Blackboard',
        'Menu/shape_detection': 'Shape Detection',
        'Menu/new_board': 'New Board',
        'Menu/history': 'History',
        'Menu/save_as_image': 'Save as Image',
        'Menu/language': 'Language',
        'Menu/language_icon': 'EN',
        'Menu/get_slack_plugin': 'Get Slack Plugin',
        'Menu/terms_of_service': 'Terms of Service',
        'Menu/privacy_policy': 'Privacy Policy',
        'History/history_title': 'History',
        'History/history_caption': 'Your board history is stored locally and will be deleted if you clear your cache.',
        'ShareButton/share': 'Share',
        'ShareButton/success': 'Board link has been copied to your clipboard.',
        'SharePopover/placeholder': 'What\'s your name?',
        'SharePopover/empty': 'You are the only one here!',
        'HelpSidebar/caption': 'Witeboard is the fastest way to collaborate real-time with your team anywhere.',
        'HelpSidebar/collaboration': 'Real-time Collaboration',
        'HelpSidebar/collaboration_caption': 'Draw & Brainstorm with your team',
        'HelpSidebar/onboarding': 'Get Started Immediately',
        'HelpSidebar/onboarding_caption': 'No need to sign up',
        'HelpSidebar/platform': 'Cross-Platform',
        'HelpSidebar/platform_caption': 'Available on desktop, tablet, or smartphone.',
        'HelpSidebar/tools': 'Tools at your disposal',
        'HelpSidebar/shortcuts': 'Useful Shortcuts',
        'HelpSidebar/shortcuts_space': 'Click-free Drawing',
        'HelpSidebar/shortcuts_rectangle': 'Draw a Rectangle',
        'HelpSidebar/shortcuts_circle': 'Draw a Circle',
        'HelpSidebar/shortcuts_line': 'Draw a Straight Line',
        'Accounts/sign_up': 'Sign Up',
        'Accounts/sign_up_caption': 'Create an account to see your past boards across any device, and keep up to date with what’s new!',
        'Accounts/email_address': 'Email Address',
        'Accounts/first_name': 'First Name',
        'Accounts/last_name': 'Last Name',
        'Accounts/password': 'Password',
        'Accounts/confirm_password': 'Confirm Password',
        'Accounts/sign_up_google': 'Sign up with Google',
        'Accounts/already_have_account': 'Already have an account?',
        'Accounts/sign_in': 'Sign In',
        'Accounts/sign_in_title': 'Welcome Back!',
        'Accounts/sign_in_caption': 'Sign in to get see your past boards.',
        'Accounts/forgot_password': 'Forgot your password?',
        'Accounts/reset_password': 'Reset Password',
        'Accounts/sign_in_google': 'Sign in with Google',
        'Accounts/callout_title': 'Create a Witeboard account!',
        'Accounts/callout_caption': 'Sign up to see your past boards across any device, and keep up to date with what’s new!',
        'Erase All': 'Erase All',
        'Cancel': 'Cancel',
        'Help': 'Help',
        'Don\'t show this again': 'Don\'t show this again'
      }
    },
    cn: {
      translations: {
        'DrawingBoard/empty_caption': 'Start drawing anywhere.',
        'DrawingBoard/clear_title': 'Are you sure you want to erase the entire board?',
        'DrawingBoard/clear_caption': 'This cannot be undone.',
        'DrawingBoard/loading_message': 'Loading — hang tight!',
        'DrawingBoard/tip_undo_autocorrect': 'Tip: You can press Ctrl/Cmd + Z to undo shape correction.',
        'Feedback/feedback': 'Feedback',
        'Feedback/feedback_title': 'Help us improve!',
        'Feedback/feedback_caption': 'Let us know what you think about Witeboard - comments, critiques, questions - anything!',
        'Feedback/feedback_placeholder': 'Your comments',
        'Feedback/enter_helper': 'Press "Enter" to submit your feedback.',
        'Feedback/thank_you': 'Thanks for your feedback!',
        'Item/pencil': 'Pencil',
        'Item/text': 'Text',
        'Item/eraser': 'Eraser',
        'Item/undo': 'Undo',
        'Title/placeholder': 'Enter a title',
        'Title/enter_helper': 'Press "Enter" to save your title.',
        'Menu/blackboard': 'Blackboard',
        'Menu/shape_detection': 'Shape Detection',
        'Menu/new_board': 'New Board',
        'Menu/history': 'History',
        'Menu/save_as_image': 'Save as Image',
        'Menu/language': 'Language',
        'Menu/language_icon': 'CN',
        'Menu/get_slack_plugin': 'Get Slack Plugin',
        'Menu/terms_of_service': 'Terms of Service',
        'Menu/privacy_policy': 'Privacy Policy',
        'History/history_title': 'History',
        'History/history_caption': 'Your board history is stored locally and will be deleted if you clear your cache.',
        'DisconnectMessage/message': 'You are disconnected. You won’t be able to draw while disconnected.',
        'DisconnectMessage/reload': 'Reload',
        'ShareButton/share': 'Share',
        'ShareButton/success': 'Board link has been copied to your clipboard.',
        'SharePopover/placeholder': 'What\'s your name?',
        'SharePopover/empty': 'You are the only one here!',
        'HelpSidebar/caption': 'Witeboard is the fastest way to collaborate real-time with your team anywhere.',
        'HelpSidebar/collaboration': 'Real-time Collaboration',
        'HelpSidebar/collaboration_caption': 'Draw & Brainstorm with your team',
        'HelpSidebar/onboarding': 'Get Started Immediately',
        'HelpSidebar/onboarding_caption': 'No need to sign up',
        'HelpSidebar/platform': 'Cross-Platform',
        'HelpSidebar/platform_caption': 'Available on desktop, tablet, or smartphone.',
        'HelpSidebar/tools': 'Tools at your disposal',
        'HelpSidebar/shortcuts': 'Useful Shortcuts',
        'HelpSidebar/shortcuts_space': 'Click-free Drawing',
        'HelpSidebar/shortcuts_rectangle': 'Draw a Rectangle',
        'HelpSidebar/shortcuts_circle': 'Draw a Circle',
        'HelpSidebar/shortcuts_line': 'Draw a Straight Line',
        'Accounts/sign_up': 'Sign Up',
        'Accounts/sign_up_caption': 'Create an account to see your past boards across any device, and keep up to date with what’s new!',
        'Accounts/email_address': 'Email Address',
        'Accounts/first_name': 'First Name',
        'Accounts/last_name': 'Last Name',
        'Accounts/password': 'Password',
        'Accounts/confirm_password': 'Confirm Password',
        'Accounts/sign_up_google': 'Sign up with Google',
        'Accounts/already_have_account': 'Already have an account',
        'Accounts/sign_in': 'Sign In',
        'Accounts/sign_in_title': 'Welcome Back!',
        'Accounts/sign_in_caption': 'Sign in to get see your past boards.',
        'Accounts/forgot_password': 'Forgot your password?',
        'Accounts/reset_password': 'Reset Password',
        'Accounts/sign_in_google': 'Sign in with Google',
        'Accounts/callout_title': 'Create a Witeboard account!',
        'Accounts/callout_caption': 'Sign up to see your past boards across any device, and keep up to date with what’s new!',
        'Erase All': 'Erase All',
        'Cancel': 'Cancel',
        'Help': 'Help',
        'Don\'t show this again': 'Don\'t show this again'
      }
    },
    ko: {
      translations: {
        'DrawingBoard/empty_caption': '오늘은 어떤 아이디어를 갖고 계신가요? 팀원들과 공유하세요!',
        'DrawingBoard/clear_title': '이 보드를 완전히 지우시겠습니까?',
        'DrawingBoard/clear_caption': '완전히 지우면 되돌릴 수 없습니다.',
        'DrawingBoard/loading_message': '화이트보드를 로딩 중입니다 - 잠시만 기다리세요.',
        'DrawingBoard/tip_undo_autocorrect': '팁: Ctrl/Cmd + Z 단축키로 자동 도형 그리기를 취소할 수 있습니다.',
        'Feedback/feedback': '피드백',
        'Feedback/feedback_title': '고객님의 의견은 저희에게 큰 도움이 됩니다.',
        'Feedback/feedback_caption': '화이트보드에 대한 의견을 전해주세요 - 문제점, 질문 등 어떤 의견이나 괜찮습니다.',
        'Feedback/feedback_placeholder': '의견을 작성해주세요',
        'Feedback/enter_helper': '"Enter" 키를 눌러 의견을 보내세요.',
        'Feedback/thank_you': '감사합니다!',
        'Item/pencil': '펜슬',
        'Item/text': '텍스트',
        'Item/eraser': '지우개',
        'Item/undo': '취소',
        'Title/placeholder': '제목을 입력하세요',
        'Title/enter_helper': '"Enter" 키를 눌러 제목을 저장하세요.',
        'Menu/blackboard': '블랙보드',
        'Menu/shape_detection': '자동 도형 그리기',
        'Menu/new_board': '새 보드',
        'Menu/history': '히스토리',
        'Menu/save_as_image': '이미지로 저장',
        'Menu/language': '언어',
        'Menu/language_icon': 'KO',
        'Menu/get_slack_plugin': 'Slack 플러그인',
        'Menu/terms_of_service': '이용약관',
        'Menu/privacy_policy': '개인정보처리방침',
        'History/history_title': '히스토리',
        'History/history_caption': '히스토리는 고객님의 컴퓨터에 저장되며, 브라우저 쿠키를 삭제할 경우 히스토리도 삭제됩니다.',
        'DisconnectMessage/message': '인터넷 연결이 끊어졌습니다. 연결이 끊어졌을 때는 화이트보드를 사용할 수 없습니다.',
        'DisconnectMessage/reload': '다시 연결',
        'ShareButton/share': '공유하기',
        'ShareButton/success': '링크가 클립보드에 복사되었습니다.',
        'SharePopover/placeholder': '이름을 입력해주세요',
        'SharePopover/empty': '아직 아무도 없습니다. 팀원들과 공유해보세요!',
        'HelpSidebar/caption': '화이트보드는 언제 어디서든 가장 빠르게 팀원들과 협업할 수 있는 공간입니다.',
        'HelpSidebar/collaboration': '실시간 협업',
        'HelpSidebar/collaboration_caption': '팀원들과 같이 그리면서 회의하세요.',
        'HelpSidebar/onboarding': '곧바로 시작하세요',
        'HelpSidebar/onboarding_caption': '가입NO, 다운로드NO!',
        'HelpSidebar/platform': '크로스 플랫폼',
        'HelpSidebar/platform_caption': '컴퓨터, 태블릿, 휴대폰 어디서든 이용하세요.',
        'HelpSidebar/tools': '도구',
        'HelpSidebar/shortcuts': '유용한 단축키',
        'HelpSidebar/shortcuts_space': '퀵 드로우',
        'HelpSidebar/shortcuts_rectangle': '사각형',
        'HelpSidebar/shortcuts_circle': '원',
        'HelpSidebar/shortcuts_line': '선',
        'Accounts/sign_up': '회원가입',
        'Accounts/sign_up_caption': '회원가입을 하시면 언제 어디서나 작업한 보드를 볼 수 있고, 새로운 업데이트 소식을 먼저 접할 수 있습니다.',
        'Accounts/email_address': '이메일',
        'Accounts/first_name': '이름',
        'Accounts/last_name': '성',
        'Accounts/password': '비밀번호',
        'Accounts/confirm_password': '비밀번호 재확인',
        'Accounts/sign_up_google': '구글로 회원가입',
        'Accounts/already_have_account': '이미 회원이신가요?',
        'Accounts/sign_in': '로그인',
        'Accounts/sign_in_title': '환영합니다!',
        'Accounts/sign_in_caption': '로그인을 하시면 예전에 작업한 보드를 다시 열 수 있습니다.',
        'Accounts/forgot_password': '비밀번호를 잊으셨나요?',
        'Accounts/reset_password': '비밀번호 변경',
        'Accounts/sign_in_google': '구글로 로그인',
        'Accounts/callout_title': '화이트보드 계정을 만드세요!',
        'Accounts/callout_caption': '회원가입을 하시면 언제 어디서나 작업한 보드를 볼 수 있고, 새로운 업데이트 소식을 먼저 접할 수 있습니다.',
        'Erase All': '완전히 지우기',
        'Cancel': '취소',
        'Help': '도움말',
        'Don\'t show this again': '다시보지 않기'
      }
    },
  },
  fallbackLng: "en",
  debug: true,

  // have a common namespace used around the full app
  ns: ["translations"],
  defaultNS: "translations",

  keySeparator: false, // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ","
  },

  react: {
    wait: true
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./app/i18n.js